








































import Vue from "vue";
import Component from "vue-class-component";
import { Model } from "vue-property-decorator";
import { focusNext } from "@/lib/formHelpers";
import { $t } from "@/lib/i18nHelpers";
import { FormField, FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import PaymentSystemLogo from "../PaymentSystemLogo";

@Component({ name: "CardDetailsForm", components: { PaymentSystemLogo, BaseInput, BaseForm } })
export default class CardDetailsForm extends Vue {
  @Model("input", { required: true })
  public readonly values!: FormValues;

  public fields: FormFields = [
    {
      name: "cardNumber",
      label: $t("Card Number"),
      pattern: "\\d*",
      type: "tel",
      rules: ["required", "credit_card"],
      maxlength: "16",
    },
    {
      name: "expireDate",
      label: $t("Expiration Date"),
      fieldClass: "inline-field mr-6",
      pattern: "\\d*",
      type: "tel",
      rules: ["required", "max:2", "min:1", "numeric"],
    },
    {
      name: "cvc",
      label: $t("CVV code"),
      fieldClass: "inline-field",
      pattern: "\\d*",
      type: "tel",
      rules: ["required", "max:4", "min:3", "numeric"],
    },
    {
      name: "nameOnCard",
      label: $t("Name on card"),
      rules: ["required", "alpha_spaces"],
    },
  ];

  public onFormInput(v: FormValues, e: InputEvent, field: FormField) {
    const target = e.target as HTMLInputElement;
    if (
      (field.name === "cardNumber" && target.value.length === 16) ||
      (field.name === "expireDate" && target.value.length === 2) ||
      (field.name === "cvc" && target.value.length === 4)
    ) {
      focusNext(target.value, target);
    }
    this.$emit("input", v);
  }
}
